/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./api/ContentFilterAPI',
	'../../../lib/@waca/dashboard-common/dist/core/APIFactory'
], function(_, ContentFilterAPI, APIFactory) {

	class ContentFilter {

		constructor(options) {
			this.content = options.content;
			this.logger = options.logger || console;
			this._api = APIFactory.createAPI(this, [ContentFilterAPI]);

			// Default content filter provider for type selector
			this._providers = {
				type: {
					match: function({ selector, layout }) {
						if (selector.type) {
							return (layout && layout.type === selector.type) || this.content.getType() === selector.type;
						}
						return false;
					}.bind(this)
				}
			};
		}

		getAPI() {
			return this._api;
		}

		registerProvider(key, provider) {
			this._providers[key] = provider;
		}

		match(options = {}){
			let isMatch = false;
			for (let key in options.selector) {
				try {
					if (this._providers[key] && this._providers[key].match(options)){
						isMatch = true;
					} else {
						isMatch = false;
						break;
					}
				} catch (e) {
					// It should not be a fail everything
					this.logger.error(e);
				}
			}
			return isMatch;
		}
	}

	return ContentFilter;

});
